export const dealsTopData =
{
  componentHeading: "Build your contract",
  componentDescription: "Follow these few easy steps to make sure your contract gives you what you need",
  selectedMessage: "Okay! You’ve selected a great device…",
  selectedDeviceDetails: {
    title: "Apple Iphone 11 pro",
    imageUrl: "assets/images/front5.png",
    storageSize: [
      {
        id: "1",
        label: "64GB"
      },
      {
        id: "2",
        label: "128GB"
      },
      {
        id: "3",
        label: "256GB"
      }
    ],
    colorVariants: [
      {
        id: "1",
        code: "color",
        hex: "#778077",
        label: "Midnight Green"
      },
      {
        id: "2",
        code: "color",
        hex: "#424648",
        label: "Space Grey"
      }
    ],
  },
  dealLink:"Choose another device"
};
export const mockSkuList = {
  "items":  [
    {
        "name": "BundleProd",
        "sku": "1280464749",
        "badges": null,
        "data": 60,
        "minutes": 200,
        "airtime": 100,
        "sms": null,
        "plan_type": 5539,
        "plan_type_label": "Data only",
        "contract_type": 5540,
        "contract_type_label": "Standard contract",
        "monthly_recurring": 400,
        "payment_terms": 5477,
        "payment_terms_label": "36",
        "badges_label": null,
        "manufacturer": null,
        "manufacturer_label": null,
        "promotion_tag": 5512,
        "promotion_tag_label": "Black Friday",
        "accessories": 5547,
        "accessories_label": "Apple Airpods",
        "plan_name": 5542,
        "plan_name_label": "myRed",
        "stock_status": "OUT_OF_STOCK",
        "low_stock_threshold": 5,
        "display_low_stock_badge": 0,
        "categories": [
            {
                "id": 59,
                "name": "Tablets & Laptops",
                "url_key": "tablets-laptops",
                "image": "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Tablets_laptop.png"
            },
            {
                "id": 69,
                "name": "Gaming",
                "url_key": "gaming",
                "image": "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Gaming_1.png"
            }
        ],
        "__typename": "BundleProduct",
        "price_range": {
            "minimum_price": {
                "regular_price": {
                    "value": 0,
                    "currency": "ZAR"
                },
                "final_price": {
                    "value": 0,
                    "currency": "ZAR"
                },
                "discount": {
                    "amount_off": 0,
                    "percent_off": 0
                }
            },
            "maximum_price": {
                "regular_price": {
                    "value": 0,
                    "currency": "ZAR"
                },
                "final_price": {
                    "value": 0,
                    "currency": "ZAR"
                },
                "discount": {
                    "amount_off": 0,
                    "percent_off": 0
                }
            }
        },
        "price_tiers": [],
        "image": {
            "url": "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/c/acer-chromebook-11-c732.png",
            "label": "BundleProd"
        },
        "small_image": {
            "url": "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/a/c/acer-chromebook-11-c732.png",
            "label": "BundleProd"
        },
        "dynamic_sku": true,
        "dynamic_price": false,
        "dynamic_weight": true,
        "price_view": "PRICE_RANGE",
        "ship_bundle_items": "TOGETHER",
        "items": [
            {
                "option_id": 95,
                "title": "laptop1",
                "required": true,
                "type": "radio",
                "position": 1,
                "sku": "1280464749",
                "options": [
                    {
                        "id": 103,
                        "quantity": 10,
                        "position": 1,
                        "is_default": true,
                        "price": 0,
                        "price_type": "FIXED",
                        "can_change_quantity": false,
                        "label": "Acer ChromeBook R11, Black",
                        "product": {
                            "id": 825,
                            "name": "Acer ChromeBook R11, Black",
                            "sku": "102065700",
                            "quantity": null,
                            "__typename": "SimpleProduct",
                            "price_range": {
                                "minimum_price": {
                                    "regular_price": {
                                        "value": 1000,
                                        "currency": "ZAR"
                                    },
                                    "final_price": {
                                        "value": 1000,
                                        "currency": "ZAR"
                                    },
                                    "discount": {
                                        "amount_off": 0,
                                        "percent_off": 0
                                    }
                                }
                            }
                        }
                    }
                ]
            },
            {
                "option_id": 96,
                "title": "Kit",
                "required": true,
                "type": "radio",
                "position": 2,
                "sku": "1280464749",
                "options": [
                    {
                        "id": 104,
                        "quantity": 10,
                        "position": 1,
                        "is_default": true,
                        "price": 0,
                        "price_type": "FIXED",
                        "can_change_quantity": false,
                        "label": "V-Home ",
                        "product": {
                            "id": 824,
                            "name": "V-Home ",
                            "sku": "108017087",
                            "quantity": 5959,
                            "__typename": "SimpleProduct",
                            "price_range": {
                                "minimum_price": {
                                    "regular_price": {
                                        "value": 5479,
                                        "currency": "ZAR"
                                    },
                                    "final_price": {
                                        "value": 799,
                                        "currency": "ZAR"
                                    },
                                    "discount": {
                                        "amount_off": 4680,
                                        "percent_off": 85.42
                                    }
                                }
                            }
                        }
                    }
                ]
            }
        ]
    },
    {
        "name": "NO PHONE + VHOME - STARTER KIT @ R150 PM (R150 Finance + R0 Sub) on Ciot - TOTAL R179 (Incl R29 Vsim subs)",
        "sku": "1280464750",
        "badges": null,
        "data": 60,
        "minutes": 200,
        "airtime": 40,
        "sms": null,
        "plan_type": 5537,
        "plan_type_label": "Data & Voice",
        "contract_type": 5540,
        "contract_type_label": "Standard contract",
        "monthly_recurring": 500,
        "payment_terms": 5477,
        "payment_terms_label": "36",
        "badges_label": null,
        "manufacturer": null,
        "manufacturer_label": null,
        "promotion_tag": 5497,
        "promotion_tag_label": "For Today Only",
        "accessories": 5547,
        "accessories_label": "Apple Airpods",
        "plan_name": 5542,
        "plan_name_label": "myRed",
        "stock_status": "IN_STOCK",
        "low_stock_threshold": 5,
        "display_low_stock_badge": 0,
        "categories": [
            {
                "id": 69,
                "name": "Gaming",
                "url_key": "gaming",
                "image": "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Gaming_1.png"
            }
        ],
        "__typename": "BundleProduct",
        "price_range": {
            "minimum_price": {
                "regular_price": {
                    "value": 12000,
                    "currency": "ZAR"
                },
                "final_price": {
                    "value": 12000,
                    "currency": "ZAR"
                },
                "discount": {
                    "amount_off": 0,
                    "percent_off": 0
                }
            },
            "maximum_price": {
                "regular_price": {
                    "value": 12000,
                    "currency": "ZAR"
                },
                "final_price": {
                    "value": 12000,
                    "currency": "ZAR"
                },
                "discount": {
                    "amount_off": 0,
                    "percent_off": 0
                }
            }
        },
        "price_tiers": [],
        "image": {
            "url": "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/static/version1600419101/graphql/_view/en_GB/Magento_Catalog/images/product/placeholder/image.jpg",
            "label": "NO PHONE + VHOME - STARTER KIT @ R150 PM (R150 Finance + R0 Sub) on Ciot - TOTAL R179 (Incl R29 Vsim subs)"
        },
        "small_image": {
            "url": "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/static/version1600419101/graphql/_view/en_GB/Magento_Catalog/images/product/placeholder/small_image.jpg",
            "label": "NO PHONE + VHOME - STARTER KIT @ R150 PM (R150 Finance + R0 Sub) on Ciot - TOTAL R179 (Incl R29 Vsim subs)"
        },
        "dynamic_sku": true,
        "dynamic_price": false,
        "dynamic_weight": true,
        "price_view": "PRICE_RANGE",
        "ship_bundle_items": "TOGETHER",
        "items": [
            {
                "option_id": 97,
                "title": "Phone1",
                "required": true,
                "type": "radio",
                "position": 1,
                "sku": "1280464750",
                "options": [
                    {
                        "id": 105,
                        "quantity": 1,
                        "position": 1,
                        "is_default": true,
                        "price": 0,
                        "price_type": "FIXED",
                        "can_change_quantity": false,
                        "label": "Apple iPhone 11 Pro Max",
                        "product": {
                            "id": 818,
                            "name": "Apple iPhone 11 Pro Max",
                            "sku": "104046524-1",
                            "quantity": null,
                            "__typename": "SimpleProduct",
                            "price_range": {
                                "minimum_price": {
                                    "regular_price": {
                                        "value": 24859,
                                        "currency": "ZAR"
                                    },
                                    "final_price": {
                                        "value": 22999,
                                        "currency": "ZAR"
                                    },
                                    "discount": {
                                        "amount_off": 1860,
                                        "percent_off": 7.48
                                    }
                                }
                            }
                        }
                    }
                ]
            },
            {
                "option_id": 98,
                "title": "Kit",
                "required": false,
                "type": "radio",
                "position": 2,
                "sku": "1280464750",
                "options": [
                    {
                        "id": 106,
                        "quantity": 1,
                        "position": 1,
                        "is_default": true,
                        "price": 0,
                        "price_type": "FIXED",
                        "can_change_quantity": false,
                        "label": "V-Home ",
                        "product": {
                            "id": 824,
                            "name": "V-Home ",
                            "sku": "108017087",
                            "quantity": 5959,
                            "__typename": "SimpleProduct",
                            "price_range": {
                                "minimum_price": {
                                    "regular_price": {
                                        "value": 5479,
                                        "currency": "ZAR"
                                    },
                                    "final_price": {
                                        "value": 799,
                                        "currency": "ZAR"
                                    },
                                    "discount": {
                                        "amount_off": 4680,
                                        "percent_off": 85.42
                                    }
                                }
                            }
                        }
                    }
                ]
            }
        ]
    },
    {
        "name": "Apple iPhone 8 Pro + @ R200 With 20GB Data Free",
        "sku": "1280464751",
        "badges": null,
        "data": 40,
        "minutes": 300,
        "airtime": 20,
        "sms": null,
        "plan_type": 5537,
        "plan_type_label": "Data & Voice",
        "contract_type": 5540,
        "contract_type_label": "Standard contract",
        "monthly_recurring": 300,
        "payment_terms": 5478,
        "payment_terms_label": "12",
        "badges_label": null,
        "manufacturer": null,
        "manufacturer_label": null,
        "promotion_tag": 5512,
        "promotion_tag_label": "Black Friday",
        "accessories": 5548,
        "accessories_label": "Apple TV 4K 64GB",
        "plan_name": 5542,
        "plan_name_label": "myRed",
        "stock_status": "OUT_OF_STOCK",
        "low_stock_threshold": 5,
        "display_low_stock_badge": 0,
        "categories": [
            {
                "id": 49,
                "name": "Phones & Sim",
                "url_key": "phones",
                "image": "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/tmp/category/Phone_SIM.png"
            },
            {
                "id": 50,
                "name": "Smartphones",
                "url_key": "smartphones",
                "image": null
            }
        ],
        "__typename": "BundleProduct",
        "price_range": {
            "minimum_price": {
                "regular_price": {
                    "value": 20000,
                    "currency": "ZAR"
                },
                "final_price": {
                    "value": 4000,
                    "currency": "ZAR"
                },
                "discount": {
                    "amount_off": 16000,
                    "percent_off": 80
                }
            },
            "maximum_price": {
                "regular_price": {
                    "value": 20000,
                    "currency": "ZAR"
                },
                "final_price": {
                    "value": 4000,
                    "currency": "ZAR"
                },
                "discount": {
                    "amount_off": 16000,
                    "percent_off": 80
                }
            }
        },
        "price_tiers": [],
        "image": {
            "url": "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/5/1/516gyfgghql._sy879_.jpg",
            "label": "Apple iPhone 8 Pro + @ R200 With 20GB Data Free"
        },
        "small_image": {
            "url": "https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/media/catalog/product/cache/f9f5b1926d03c6b3fb82c0014bb23c4b/5/1/516gyfgghql._sy879_.jpg",
            "label": "Apple iPhone 8 Pro + @ R200 With 20GB Data Free"
        },
        "dynamic_sku": true,
        "dynamic_price": false,
        "dynamic_weight": true,
        "price_view": "PRICE_RANGE",
        "ship_bundle_items": "TOGETHER",
        "items": [
            {
                "option_id": 99,
                "title": "Phone1",
                "required": true,
                "type": "radio",
                "position": 1,
                "sku": "1280464751",
                "options": [
                    {
                        "id": 107,
                        "quantity": 10,
                        "position": 1,
                        "is_default": true,
                        "price": 0,
                        "price_type": "FIXED",
                        "can_change_quantity": false,
                        "label": "Apple iPhone 11 Pro Max",
                        "product": {
                            "id": 818,
                            "name": "Apple iPhone 11 Pro Max",
                            "sku": "104046524-1",
                            "quantity": null,
                            "__typename": "SimpleProduct",
                            "price_range": {
                                "minimum_price": {
                                    "regular_price": {
                                        "value": 24859,
                                        "currency": "ZAR"
                                    },
                                    "final_price": {
                                        "value": 22999,
                                        "currency": "ZAR"
                                    },
                                    "discount": {
                                        "amount_off": 1860,
                                        "percent_off": 7.48
                                    }
                                }
                            }
                        }
                    }
                ]
            },
            {
                "option_id": 100,
                "title": "Kit",
                "required": true,
                "type": "radio",
                "position": 2,
                "sku": "1280464751",
                "options": [
                    {
                        "id": 108,
                        "quantity": 10,
                        "position": 1,
                        "is_default": true,
                        "price": 0,
                        "price_type": "FIXED",
                        "can_change_quantity": false,
                        "label": "V-Home ",
                        "product": {
                            "id": 824,
                            "name": "V-Home ",
                            "sku": "108017087",
                            "quantity": 5959,
                            "__typename": "SimpleProduct",
                            "price_range": {
                                "minimum_price": {
                                    "regular_price": {
                                        "value": 5479,
                                        "currency": "ZAR"
                                    },
                                    "final_price": {
                                        "value": 799,
                                        "currency": "ZAR"
                                    },
                                    "discount": {
                                        "amount_off": 4680,
                                        "percent_off": 85.42
                                    }
                                }
                            }
                        }
                    }
                ]
            }
        ]
    }
]
}

export const mockPlanType = [
    {
      "label": "Data & Voice Minutes"
    },
    {
      "label": "Airtime"
    },
    {
      "label": "Data only"
    }
  ]